const ReactDataGrid = require('react-data-grid');
const { Toolbar, Filters: { NumericFilter, AutoCompleteFilter },Data: { Selectors } } = require('react-data-grid-addons');
const React = require('react');
import ReactDOM from 'react-dom';
import Fade from '../utils/Fade';
import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';
import TableExport from'../export/jqueryTableExport';
require('./OnLineUser.css');

export default class OnLineUser extends React.Component {

  constructor(props) {
    super(props);
    
    var columns=[
        {
            key: 'userId',
            name: "用户ID",
            width: 70,
            resizable: true,
            filterable: true,
            filterRenderer: AutoCompleteFilter
        },
        {
            key: 'clientSessionId',
            name: "会话ID",
            width:200,
            resizable: true,
            filterable: true
        },
        {
            key: 'loginDate',
            name: "登录日期",
            width:85,
            resizable: true,
            filterable: true,
            filterRenderer: AutoCompleteFilter
            //formatter:<NetWorkErrorDateTimeRender/>
        },
        {
            key: 'loginTime',
            name: "登录时间",
            width:80,
            resizable: true,
            filterable: true,
            filterRenderer: AutoCompleteFilter
        },
        {
            key: 'lastCallIn',
            name: "最后访问-进",
            width:140,
            resizable: true,
            filterable: true,
            filterRenderer: AutoCompleteFilter
        },
        {
            key: 'lastCallOut',
            name: "最后访问-出",
            width:140,
            resizable: true,
            filterable: true,
            filterRenderer: AutoCompleteFilter
        }
    ];
    
    this.columns = columns;
    this.state ={
      rows:this.props.fdataProvider, 
      selectedIndexes: [0],
      title: this.props.title + "(" + (this.props.fdataProvider?this.props.fdataProvider.length:0) + ")",
      filters: {} 
    }

  }
  

  static show(fdataProvider, title) {
    
      ReactDOM.render(
        
        <OnLineUser fdataProvider={fdataProvider}  title={title} />
        
        ,document.getElementById('onLineUserModal')
      )
      
  }
  componentDidMount()
  {
    $(this.netWorkErrorLogContainer).draggable({
      handle: ".modal-header" // 只能点击头部拖动
    }); //为模态对话框添加拖拽

    $("#onLineUserModal").css("display","flex");   
  }

  close=()=>
  {
    let $reactComponentContainer = $("#onLineUserModal");
    ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
    $("#onLineUserModal").css("display","none");
  }

  
  getRowAt = (index) => {
    let rows = this.getRows();
    if (index < 0 || index > this.getSize()) {
      return undefined;
    }

    return rows[index];

  };

  getRows() {
    return Selectors.getRows(this.state);
  }

  handleFilterChange(filter) {
    let newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({ filters: newFilters });
  }

  onClearFilters() {
    // all filters removed
    this.setState({filters: {} });
  }

  getValidFilterValues(columnId) {
    let values = this.state.rows.map(r => r[columnId]);
    return values.filter((item, i, a) => { return i === a.indexOf(item); });
  }


  getSize = () => {
    return this.getRows().length;
  };

  rowClick = (index,record,proxy) =>{

    this.setState({ selectedIndexes:[index]});
  }

  gridKeyDown(proxy)
  {
    //console.log(arguments);
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];
     
      if(ne.keyCode == 40 || ne.keyCode == 38)
      {
        let record = null;
        var newSelectIndexes = this.state.selectedIndexes.slice();
        if(newSelectIndexes.length == 0)
        {
          if(this.state.rows.length>0)
          {
            record = ne.keyCode == 40?this.state.rows[0]:this.state.rows[this.state.rows.length-1];
            newSelectIndexes.push(0);
          }
        }
        else
        {
          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
          let newIndex = ne.keyCode==40?lastIndex+1:lastIndex-1;
          let total = this.state.rows.length;
          if(newIndex>=0&&newIndex<total)
          {
            record = this.state.rows[newIndex];
            newSelectIndexes = [newIndex];
          }
        }
        
        this.setState({selectedIndexes:newSelectIndexes});
        return true;
      }
     
    }
  }

  sendMessage()
  {
      let selectedIndexes = this.state.selectedIndexes;
      if(selectedIndexes && selectedIndexes.length>0)
      {
          let _body = $(this.txt).val();
          if(!_body)
          {
            Fade.show({text:"请填写消息内容"});
            return;
          }
          let mo = {remoteClass:"gongqi.erp.framework.message.MessageObject"};
          mo.from = window.userInfos.userSessionId+","+window.userInfos.userId;
          mo.subject = "[管理员通知]";
          mo.to = "";
          for(let i = 0;i<selectedIndexes.length;i++)
          {
            let user = this.state.rows[selectedIndexes[i]];
            mo.to+=(user["clientSessionId"]+","+user["userId"]+"|");
          }
          if(mo.to.length>0)
            mo.to = mo.to.substr(0,mo.to.length-1);
          mo.bodyLabel = "通知";
          mo.bodyType = "String";
          mo.body = _body;
          mo.time = new Date().Format("yyyy-MM-dd HH:mm:ss");
          mo.modal = $(this.important).is(':checked');

          let command = Command.createService("gongqi.erp.framework.services.MessageService",
                        "dispatchMessage","void");
          command.appendArg(mo,"MessageObject");
          ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.result_sendMessage_Handler.bind(this)});

      }
      else
      {
          Fade.show({text:"请选择需要通知的用户"});
      }
  }

  result_sendMessage_Handler(data)
  {
    Fade.show({text:"消息已发送"});
    $(this.txt).val("");
    $(this.important).removeAttr("checked");
  }

  refreshUsers()
  {
    ServiceHelper.call("gongqi.erp.framework.services.UserSessionService",
                "findAllDetail","List",this.result_refreshUserList.bind(this),false
    );
  }

  result_refreshUserList(data)
  {
    let list = data.result;
    this.setState({rows:list});
  }

  deleteUsers()
  {
    let selectedIndexes = this.state.selectedIndexes;
    if(selectedIndexes && selectedIndexes.length>0)
    {
      let user = this.state.rows[selectedIndexes[0]];
      if(!user)return;
      let sessionId = user.clientSessionId;
      if(sessionId != window.userInfos.userSessionId)
      {
        ServiceHelper.call(
          "gongqi.erp.framework.services.UserSessionService",
          "kickOffSession",
          "void",
          this.rpc_result_kickUser.bind(this),false,null,sessionId
        );
      }
    }
  }

  exportUsers()
  {
    var options={
      type:'excel'
    };
    let exportHeads = [];
    for(let i = 0;i<this.columns.length;i++)
    {
      let col = this.columns[i];
      let item = {dataField:col.key, name:col.name, columnType:"String"};
      exportHeads.push(item);
    }

    
  		const ac=this.state.rows.slice();
  		var exportBodys=[];
      for(var i=0;i<ac.length;i++){
        var item=ac[i];
        var exportBody=[];
        for(var j =0;j<exportHeads.length;j++){
          var key=exportHeads[j].dataField;
          exportBody.push(item[key]);

        }
        exportBodys.push(exportBody);
      }
        
  	

    $(this.netWorkErrorLogContainer).tableExport(exportHeads,exportBodys,options);
  }

  rpc_result_kickUser()
  {
    let selectedIndexes = this.state.selectedIndexes;
    if(selectedIndexes && selectedIndexes.length>0)
    {
      let selectedIndex  = selectedIndexes[0];
      let rows = this.state.rows.slice();
      rows.splice(selectedIndex,1);
      let newSelectedIndex = (selectedIndex-1>0)?selectedIndex-1:0;
      this.setState({rows:rows,selectedIndexes:[newSelectedIndex]});
    }
  }

  onRowsSelected = rows => {
    this.setState({
      selectedIndexes: this.state.selectedIndexes.concat(
        rows.map(r => r.rowIdx)
      )
    });
  }

  onRowsDeselected = rows => {
    let rowIndexes = rows.map(r => r.rowIdx);
    this.setState({
      selectedIndexes: this.state.selectedIndexes.filter(
        i => rowIndexes.indexOf(i) === -1
      )
    });
  }

  render() {  
   
    return (
          <div ref={node=>this.netWorkErrorLogContainer=node} tabIndex="-1"  style={{position:'absolute',alignSelf:"center",backgroundColor:'white',width:'800px',height:'580px',display:'flex',flexDirection:'column',background:'#FFFFFF',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
            <div className="modal-header" style={{position:"relative"}}>
                <div className="modal-close" onClick={this.close.bind(this)}></div>
                
                <h5 className="modal-title" style={{fontWeight:'bolder',fontSize:'16px'}}>{this.state.title}</h5>
            </div>
            <div style={{display:'flex',flexDirection:'column',flexGrow:100,padding:'5px'}}>
               
                    <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',marginBottom:'5px'}} ref={node=>this.gridContainer=node}>
                    
                        <ReactDataGrid        
                          ref={ node => this.grid = node }
                          // onGridSort={this.handleGridSort}
                          enableCellSelect={true}
                          columns={this.columns}//columns={this.state.columns}
                          // columns={this.props.columns}
                          // columns={this.getColumns()}
                          rowGetter={this.getRowAt}
                          rowsCount={this.getSize()}
                          //onGridRowsUpdated={this.handleGridRowsUpdated}
                          // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
                          enableRowSelect={false}
                          onGridKeyDown={this.gridKeyDown.bind(this)}
                          rowSelection={{
                            showCheckbox: true,
                            enableShiftSelect: true,
                            onRowsSelected: this.onRowsSelected,
                            onRowsDeselected: this.onRowsDeselected,
                            selectBy: {
                                indexes: this.state.selectedIndexes
                            }
                          }}
                          //onRowClick={this.rowClick}//this.rowClick this.rowClick.bind(this)
                          rowHeight={30}
                          minHeight={250}
                          rowScrollTimeout={500} 
                          cellNavigationMode="loopOverRow"
                          toolbar={<Toolbar enableFilter={true}/>}
                          onAddFilter={this.handleFilterChange.bind(this)}
                          onClearFilters={this.onClearFilters.bind(this)} 
                          getValidFilterValues={this.getValidFilterValues.bind(this)}
                        />
                          
                    </div>
              <textarea rows="10" placeholder="此处键入消息内容" ref={node=>this.txt=node} style={{border:'1px solid #E0E2E6',borderRadius:'4px'}}></textarea>
              <div className="onLineUser_important" style={{display:'flex',flexDirection:'row',flexGrow:0,padding:'10px 0',alignItems:'center',justifyContent:'flex-end'}}>
                <div style={{marginRight:'7px',position:'relative',width:'18px',height:'18px'}}>
                  <input type="checkbox" id="onlineuser_text" ref={node=>this.important=node}></input>
                  <label htmlFor="onlineuser_text"></label>
                </div>
                <label style={{marginTop:'4px',marginRight:'20px'}}>重要</label>
                <button className="btn btn-info" style={{color:'#0078D4',marginRight:'5px',width:'88px',height:'28px',border:'1px solid #0078D4',borderRadius:'2px'}} onClick={this.sendMessage.bind(this)}>
                  <i className="fa fa-paper-plane-o" style={{color:'#0078D4',marginRight:'5px'}}></i>发送
                </button>
                <button className="btn btn-info" style={{color:'#0078D4',marginRight:'5px',width:'88px',height:'28px',border:'1px solid #0078D4',borderRadius:'2px'}} onClick={this.refreshUsers.bind(this)}>
                  <i className="fa fa-repeat" style={{color:'#0078D4',marginRight:'5px'}}></i>刷新
                </button>
                <button className="btn btn-info" style={{color:'#0078D4',marginRight:'5px',width:'88px',height:'28px',border:'1px solid #0078D4',borderRadius:'2px'}} onClick={this.deleteUsers.bind(this)}>
                  <i className="fa fa-trash-o" style={{color:'#0078D4',marginRight:'5px'}}></i>删除
                </button>
                <button className="btn btn-info" style={{color:'#0078D4',width:'88px',height:'28px',border:'1px solid #0078D4',borderRadius:'2px'}} onClick={this.exportUsers.bind(this)}>
                  <i className="fa fa-file-excel-o" style={{color:'#0078D4',marginRight:'5px'}}></i>导出
                </button>
              </div>
          </div>

          
         </div>);
        
  }
}



// WEBPACK FOOTER //
// ./src/onlineuser/OnLineUser.js